import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import { AccountSharedModule } from 'apps/account/src/account-shared';
import { HeaderNavComponent } from './components/header-nav/header-nav.component';
import { HeaderComponent } from './header.component';


@NgModule({
    imports: [
        CommonModule,
        AccountSharedModule,
        UIRouterUpgradeModule.forChild({})
    ],
    declarations: [
        HeaderComponent,
        HeaderNavComponent
    ],
    exports: [
        HeaderComponent,
        HeaderNavComponent
    ]
})
export class HeaderModule {

}
